const Loader = ({ label = 'Loading…' }) => (
  <div style={{ padding: 40, textAlign: 'center' }}>
    <div style={{
      width: 36, height: 36, margin: '0 auto 12px',
      border: '3px solid #e6ebf0', borderTopColor: '#A67C00',
      borderRadius: '50%', animation: 'bkSpin 0.8s linear infinite',
    }} />
    <p style={{ color: '#64748b', fontSize: 13 }}>{label}</p>
    <style>{`@keyframes bkSpin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export default Loader;